module.exports = __webpack_public_path__ + "images/pricing-cyber-monday-banner.jpg";